import React from 'react/addons';
import _ from 'underscore';
import {gettext} from 'ofs/i18n';
import $ from 'jquery';
import moment from 'ofs/moment';

import PrestayContentSection from 'ofs/apps/bookings/prestay/views/PrestayContentSection';
import TimeField from 'ofs/react/fields/timefield';
import Row from 'ofs/forms/layout/row';
import Column from 'ofs/forms/layout/column';
import Appointments from 'ofs/apps/bookings/prestay/views/Appointments';
import SaveButton from '../views/SaveButton';

const messages = {
  SAVE_CONTINUE: gettext("Save and continue"),
  DEPARTURE: gettext("Departure"),
  STANDARD_DEPARTURE: gettext("Standard departure is any time before"),
  LEAVE_LATER: gettext("Want to leave later?"),
  CLICK_HERE: gettext("Click here"),
  WHAT_TIME_LEAVE: gettext("What time would you want to leave?"),
  FIND_AVAILABLE: gettext("Find available appointments"),
};

module.exports = function(config) {

  const AppointmentWrapper = React.createClass({
    getInitialState() {
      return {
        loading: false
      };
    },

    modelChanged() {
      if (_.size(this.props.model.get('appointments')) > 0) {
        this.setState({loading: false});
      }
    },

    componentDidMount() {
      this.props.model.on("change", _.bind(this.modelChanged, this));
    },

    componentWillUnmount() {
      this.props.model.off(null, null, this);
    },

    handleClick() {
      this.setState({loading: true});
      $.post(config.appointments_endpoint, 
        {etd: this.props.model.get('etd')}, 
        ((data) => {
          this.props.model.set('appointments', data.appointments);
          this.setState({loading: false});
        })
      );
    },

    render() {
      const {model} = this.props;
      const disabled = model.get('etd') ? false : true;

      return (
        <div className="appointments">
          <Row>
            <Column size="half">
              <p>{messages.WHAT_TIME_LEAVE}</p>
            </Column>
            <Column size="half">
              <TimeField name="etd" model={model} field="etd" />
            </Column>
          </Row>
          {model.get('appointments') ? <Appointments config={config} model={model} /> : <div className="ofs-Prestay__PlaceholderBox">{this.state.loading ? 'Loading' : <button className="ofs-Button ofs-Button--small" disabled={disabled} onClick={this.handleClick}>{messages.FIND_AVAILABLE}</button>}</div>}
        </div>
      );
    }
  });



  const DefaultDeparture = React.createClass({
    render() {
      return (
        <div className="ofs-Prestay__ContentIntro">
          <p>{messages.STANDARD_DEPARTURE} <strong>{moment(config.default_appointment.time, "YYYY-MM-DDTHH:mm").format('h:mm')}</strong></p>
          <p>{messages.LEAVE_LATER} <a onClick={this.props.handleClick}>{messages.CLICK_HERE}</a></p>
        </div>
       );
    }
  });

  const CustomDeparture = React.createClass({
    render() {
      return (
        <div className="custom-appointment">
          <AppointmentWrapper model={this.props.model} />
        </div>
      );
    }
  });

  const Departure = React.createClass({
    getInitialState() {
        return {
          custom: this.props.model.get('etd') ? true : false
        };
    },

    componentDidMount() {
      this.props.model.on("change", this.forceUpdate.bind(this, null), this);
    },

    componentWillUnmount() {
      this.props.model.off(null, null, this);
    },

    switchToCustom() {
      this.props.model.unset('selected_appointment');
      this.setState({custom: true});
    },

    render() {
      const {model, contact} = this.props;
      const isValid = model.isValid();

      let payload = model.toJSON();

      delete payload.appointments;
      delete payload.selected_appointment;

      const appointment = model.get('selected_appointment');

      if (appointment) {
        payload['appointment_type'] = appointment.type;
        payload['appointment_time'] = appointment.time;

        if (config.admin) {
          payload['price_override'] = model.get('price_override');
        }
      }

      return (
        <form className="departure-form" method="post" action=".">
          <PrestayContentSection title={messages.DEPARTURE}>
            <input type="hidden" name="payload" value={JSON.stringify(payload)} />
            {this.state.custom ? <CustomDeparture model={model} /> : <DefaultDeparture handleClick={this.switchToCustom} />}
          </PrestayContentSection>
          {config.admin ? <button className="ofs-Button admin-only button small" disabled={!isValid}>{messages.SAVE_CONTINUE}</button> : <SaveButton model={model} email={contact.guestServicesEmail} phone={contact.guestServicesPhone}/>}
        </form>
      );
    }
  });

  return {
    Departure: Departure
  };
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/departure/views.jsx
 **/